/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { FormsContext } from '../components';

import type { FormState } from '../entries';

export const useFormApi = <T,>() => useContext<FormState<T>>(FormsContext);
